module.exports = __webpack_public_path__ + "img/pzgl.05cf9fce.png";